import mod from "-!../../../../node_modules/babel-loader/lib/index.js??ref--3!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./savingNotification.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../../node_modules/babel-loader/lib/index.js??ref--3!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./savingNotification.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./assets/vue/houseModel/components/savingNotification.vue?vue&type=script&lang=js&
// module id = 173
// module chunks = 0